(function () {
  if (window.JSQQuoteSubmitHandoffV1) return;
  window.JSQQuoteSubmitHandoffV1 = true;

  function installHeaderCriticalCss() {
    if (document.getElementById('jsq-runtime-header-fix')) return;
    var style = document.createElement('style');
    style.id = 'jsq-runtime-header-fix';
    style.textContent = 'html,body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}body a{color:inherit;text-decoration:none}.skip-to-content.sr-only:not(:focus),.sr-only:not(:focus){position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;padding:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;border:0!important}.skip-to-content:focus{position:fixed!important;top:10px;left:10px;z-index:9999;padding:10px 14px;border-radius:999px;background:#c59d5f;color:#070707!important;font-weight:800}height-observer:has(x-header.header){display:block!important;position:sticky!important;top:0;z-index:80;background:#050505!important;color:#fff!important}x-header.header,.header{display:grid!important;grid-template-areas:"primary logo secondary"!important;grid-template-columns:46px minmax(0,1fr)46px!important;align-items:center!important;min-height:58px!important;padding:0 14px!important;background:#050505!important;color:#fff!important;border-bottom:1px solid rgba(255,255,255,.12)!important}.header__logo{grid-area:logo;min-width:0;max-width:230px!important;justify-self:center;text-align:center;color:#fff!important}.header__primary-nav{grid-area:primary}.header__secondary-nav{grid-area:secondary}x-header.header a,.header a,header-sidebar a,.header-sidebar a{color:inherit!important;text-decoration:none!important}.header__logo-text,.header__heading-link span{display:block;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#fff!important;font-size:0!important;letter-spacing:0}.header__logo-text:after,.header__heading-link span:after{content:"JS Mobile Detailing";display:block;font-size:12px;line-height:1.15;letter-spacing:.16em;text-transform:uppercase;color:#fff}.header__primary-nav ul,.header__secondary-nav ul,.header-sidebar ul{list-style:none!important;margin:0!important;padding:0!important}.header__primary-nav .contents,.header__secondary-nav{display:none!important}.header__primary-nav button,.header button[aria-controls]{display:flex!important;width:42px!important;height:42px!important;align-items:center!important;justify-content:center!important;padding:0!important;border:0!important;border-radius:12px!important;background:transparent!important;color:#fff!important}.header button svg{width:28px!important;height:28px!important}.header-sidebar:not([open]):not(.is-open):not([data-open=true]){display:none!important}.header-sidebar[open],.header-sidebar.is-open,.header-sidebar[data-open=true]{position:fixed!important;inset:0 auto 0 0!important;z-index:120!important;display:block!important;width:min(86vw,360px)!important;padding:22px!important;background:#080808!important;color:#fff!important;box-shadow:20px 0 60px rgba(0,0,0,.55)!important;overflow:auto!important}.header-sidebar a{display:block;padding:12px 0;font-size:18px}@media(min-width:701px){x-header.header,.header{grid-template-columns:minmax(0,1fr) auto minmax(0,1fr)!important;min-height:70px!important;padding:0 38px!important}.header__logo{max-width:520px!important}.header__logo-text:after,.header__heading-link span:after{font-size:14px;letter-spacing:.22em}.header__primary-nav .contents{display:flex!important;gap:28px;align-items:center}.header__primary-nav button,.header button[aria-controls]{display:none!important}.header__secondary-nav{display:flex!important;justify-content:flex-end!important}}';
    (document.head || document.documentElement).appendChild(style);
  }

  installHeaderCriticalCss();
  document.addEventListener('DOMContentLoaded', installHeaderCriticalCss);
  setTimeout(installHeaderCriticalCss, 80);

  function scrubLiquidErrors(root) {
    var pattern = /Liquid error \([^)]+\):\s*(?:Could not find asset snippets\/[^\s<]+|font_url can only be used with a font drop)/g;
    var leakedScriptPattern = /(?:<\s*\/?\s*script\b|&lt;\s*\/?\s*script\b|document\.(?:addEventListener|querySelector|querySelectorAll)\(|window\.(?:JSQ|__jsq)|function\s*\(\)\s*\{|var\s+reviewUrl\s*=|JSQLiquidHeaderScrubV1)/i;

    function scrubTextNode(node) {
      if (!node || !node.nodeValue) return;
      if (node.nodeValue.indexOf('Liquid error') !== -1) {
        node.nodeValue = node.nodeValue.replace(pattern, '').replace(/Liquid error \([^)]+\):[^\n<]*/g, '');
      }
      if (leakedScriptPattern.test(node.nodeValue)) {
        node.nodeValue = '';
      }
    }

    function walk(node) {
      if (!node) return;
      if (node.nodeType === 3) {
        scrubTextNode(node);
        return;
      }
      if (node.nodeType !== 1 && node.nodeType !== 9 && node.nodeType !== 11) return;
      if (/^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/i.test(node.tagName || '')) return;
      for (var child = node.firstChild; child; child = child.nextSibling) walk(child);
    }

    try {
      document.documentElement.setAttribute('dir', 'ltr');
      var scope = (root && root.body) || root || document.body || document;
      if (document.createTreeWalker) {
        var textFlag = window.NodeFilter ? NodeFilter.SHOW_TEXT : 4;
        var walker = document.createTreeWalker(scope, textFlag);
        var node;
        while ((node = walker.nextNode())) scrubTextNode(node);
      } else {
        walk(scope);
      }
    } catch (error) {}
  }

  scrubLiquidErrors(document);
  document.addEventListener('DOMContentLoaded', function () { scrubLiquidErrors(document); });
  setTimeout(function () { scrubLiquidErrors(document); }, 150);
  setTimeout(function () { scrubLiquidErrors(document); }, 900);

  var key = 'jsqQuoteSubmitPendingV1';
  var phone = '+15098678979';
  var finalCta = 'Send My Quote Request';

  function clean(value, fallback) {
    value = String(value || '').replace(/\s+/g, ' ').trim();
    return value || fallback || '';
  }

  function html(value) {
    return clean(value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function byId(id) {
    return document.getElementById(id);
  }

  function quoteDetails(form) {
    function field(name, fallback) {
      var input = form.querySelector('[name="' + name + '"]');
      return clean(input && input.value, fallback);
    }

    return {
      at: Date.now(),
      name: field('contact[name]', ''),
      customerPhone: field('contact[phone]', ''),
      email: field('contact[email]', ''),
      price: clean(byId('jsqPrice') && byId('jsqPrice').textContent, field('contact[Quote Price]', 'your estimate')),
      service: clean(byId('jsqServiceText') && byId('jsqServiceText').textContent, field('contact[Quote Service]', 'mobile detailing')),
      vehicle: clean(byId('jsqVehicleText') && byId('jsqVehicleText').textContent, field('contact[Vehicle Type]', 'your vehicle')),
      condition: clean(byId('jsqConditionText') && byId('jsqConditionText').textContent, field('contact[Vehicle Condition]', 'condition review')),
      addons: clean(byId('jsqAddonsText') && byId('jsqAddonsText').textContent, field('contact[Selected Add-ons]', 'None')),
      location: field('contact[Location]', ''),
      preferredDay: field('contact[Preferred Day]', ''),
      preferredTiming: field('contact[Preferred Timing]', 'Next available opening'),
      preferredContact: field('contact[Preferred Contact]', 'Text first'),
      workArea: field('contact[Work Area]', 'Not sure yet'),
      notes: field('contact[Notes]', ''),
    };
  }

  function quoteIncomplete(details) {
    var price = clean(details && details.price).toLowerCase();
    var service = clean(details && details.service).toLowerCase();
    var vehicle = clean(details && details.vehicle).toLowerCase();
    var condition = clean(details && details.condition).toLowerCase();
    return !price ||
      /pick|choose|select|finish|incomplete|quote/.test(price) ||
      !service ||
      /choose|select|package/.test(service) ||
      !vehicle ||
      vehicle === '-' ||
      !condition ||
      condition === '-' ||
      /choose|select|needs package/.test(condition);
  }

  function installStyle() {
    if (document.getElementById('jsq-quote-submit-handoff-style')) return;
    var style = document.createElement('style');
    style.id = 'jsq-quote-submit-handoff-style';
    style.textContent = '#quoteRequestForm .jsq-booking-photo-note,#quoteRequestForm .jsq-final-trust{margin:10px 0 12px;color:rgba(255,255,255,.78);font-size:13px;line-height:1.4}#quoteRequestForm .jsq-final-trust{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}#quoteRequestForm .jsq-final-trust span{padding:9px 10px;border:1px solid rgba(197,157,95,.28);border-radius:11px;background:rgba(197,157,95,.08);font-weight:800;text-align:center}#quoteRequestForm select{min-height:48px;border:1px solid rgba(255,255,255,.16);border-radius:10px;background:rgba(255,255,255,.08);color:#fff;padding:0 12px;font-size:15px}#quoteRequestForm option{color:#111}.jsq-submit-success{width:min(900px,calc(100vw - 28px));margin:24px auto;padding:18px;border:1px solid rgba(197,157,95,.45);border-radius:18px;background:linear-gradient(135deg,rgba(197,157,95,.18),rgba(8,8,8,.92));color:#fff;box-shadow:0 18px 42px rgba(0,0,0,.28)}.jsq-submit-success strong{display:block;margin:0 0 8px;color:#fff;font-size:24px;line-height:1.1}.jsq-submit-success p{margin:0;color:rgba(255,255,255,.78);font-size:15px;line-height:1.45}.jsq-submit-success-summary{display:grid;gap:7px;margin:14px 0;padding:12px;border:1px solid rgba(255,255,255,.12);border-radius:12px;background:rgba(0,0,0,.22)}.jsq-submit-success-summary p{display:flex;justify-content:space-between;gap:12px}.jsq-submit-success-summary b{color:#fff;text-align:right}.jsq-submit-success-actions{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin-top:14px}.jsq-submit-success-actions a{display:flex;align-items:center;justify-content:center;min-height:48px;border:1px solid rgba(255,255,255,.18);border-radius:12px;color:#fff;text-decoration:none;font-weight:900}.jsq-submit-success-actions a:first-child{background:#c59d5f;color:#080808;border-color:#c59d5f}@media(max-width:700px){#quoteRequestForm .jsq-final-trust{grid-template-columns:1fr}.jsq-submit-success{margin:16px auto;padding:16px;border-radius:16px}.jsq-submit-success strong{font-size:22px}.jsq-submit-success-actions{grid-template-columns:1fr}.jsq-submit-success-summary p{display:block}.jsq-submit-success-summary b{display:block;text-align:left}}';
    document.head.appendChild(style);
  }

  function installPostSubmitStyle() {
    if (document.getElementById('jsq-post-submit-polish-v1')) return;
    var style = document.createElement('style');
    style.id = 'jsq-post-submit-polish-v1';
    style.textContent = [
      '.jsq-submit-success{position:relative;overflow:hidden;width:min(940px,calc(100vw - 28px));margin:18px auto 26px!important;padding:18px!important;border:1px solid rgba(197,157,95,.48)!important;border-radius:20px!important;background:linear-gradient(145deg,rgba(18,18,18,.98),rgba(5,5,5,.96))!important;color:#fff!important;box-shadow:0 18px 48px rgba(0,0,0,.34)!important;}',
      '.jsq-submit-success:before{content:"";position:absolute;inset:0;background:radial-gradient(circle at 18% 0%,rgba(197,157,95,.18),transparent 32%);pointer-events:none;}',
      '.jsq-submit-success>*{position:relative;z-index:1;}',
      '.jsq-submit-success-kicker{display:inline-flex;align-items:center;min-height:28px;margin:0 0 10px;padding:0 10px;border:1px solid rgba(197,157,95,.34);border-radius:999px;background:rgba(197,157,95,.10);color:#f1d296;font-size:11px;font-weight:950;letter-spacing:.08em;text-transform:uppercase;}',
      '.jsq-submit-success strong{display:block;margin:0 0 8px!important;color:#fff!important;font-size:clamp(26px,4vw,38px)!important;line-height:1.05!important;letter-spacing:0!important;}',
      '.jsq-submit-success p{margin:0;color:rgba(255,255,255,.76)!important;font-size:15px!important;line-height:1.45!important;}',
      '.jsq-submit-success-summary{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px!important;margin:14px 0!important;padding:0!important;border:0!important;background:transparent!important;}',
      '.jsq-submit-success-summary p{display:block!important;margin:0!important;padding:11px 12px!important;border:1px solid rgba(255,255,255,.12)!important;border-radius:13px!important;background:rgba(255,255,255,.055)!important;}',
      '.jsq-submit-success-summary span{display:block;margin:0 0 4px;color:rgba(255,255,255,.58);font-size:10px;font-weight:950;letter-spacing:.08em;text-transform:uppercase;}',
      '.jsq-submit-success-summary b{display:block;color:#fff!important;font-size:14px;font-weight:900;text-align:left!important;line-height:1.2;}',
      '.jsq-submit-next{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:14px 0 0;}',
      '.jsq-submit-next span{display:flex;align-items:center;justify-content:center;min-height:40px;padding:8px;border:1px solid rgba(197,157,95,.28);border-radius:12px;background:rgba(197,157,95,.08);color:rgba(255,255,255,.84);font-size:12px;font-weight:850;line-height:1.15;text-align:center;}',
      '.jsq-submit-success-actions{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px!important;margin-top:14px!important;}',
      '.jsq-submit-success-actions a{display:flex!important;align-items:center!important;justify-content:center!important;min-height:50px!important;border:1px solid rgba(255,255,255,.18)!important;border-radius:999px!important;color:#fff!important;text-decoration:none!important;font-weight:950!important;line-height:1.1!important;text-align:center!important;}',
      '.jsq-submit-success-actions a:first-child{background:#c59d5f!important;color:#080808!important;border-color:#c59d5f!important;}',
      '@media(max-width:700px){.jsq-submit-success{width:calc(100vw - 24px)!important;margin:12px auto 18px!important;padding:14px!important;border-radius:18px!important;}.jsq-submit-success strong{font-size:26px!important;}.jsq-submit-success-summary{grid-template-columns:1fr!important;gap:7px!important;}.jsq-submit-next{grid-template-columns:1fr!important;gap:7px!important;}.jsq-submit-success-actions{grid-template-columns:1fr!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function installMobileQuoteStepStyle() {
    if (document.getElementById('jsq-mobile-quote-step-polish-v1')) return;
    var style = document.createElement('style');
    style.id = 'jsq-mobile-quote-step-polish-v1';
    style.textContent = [
      '@media(max-width:1100px){',
      'html body #jsqMobileQuoteApp{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-top{border-radius:18px!important;background:linear-gradient(135deg,rgba(255,255,255,.105),rgba(255,255,255,.045))!important;box-shadow:0 12px 34px rgba(0,0,0,.24)!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-top span{font-size:10px!important;letter-spacing:.06em!important;color:rgba(255,255,255,.62)!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-top strong{font-weight:950!important;letter-spacing:0!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-price-pill{box-shadow:0 8px 18px rgba(197,157,95,.24)!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-panel,html body #jsqMobileQuoteApp .jsq-mobile-quote-summary{border-radius:18px!important;background:linear-gradient(180deg,rgba(20,20,20,.96),rgba(7,7,7,.98))!important;border-color:rgba(255,255,255,.14)!important;box-shadow:0 18px 46px rgba(0,0,0,.26)!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-panel h3,html body #jsqMobileQuoteApp .jsq-mobile-quote-summary h3{font-size:16px!important;font-weight:950!important;line-height:1.14!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-list{align-items:stretch!important;gap:9px!important;overflow:visible!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-choice{display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:center!important;gap:12px!important;min-height:72px!important;padding:13px!important;border-radius:15px!important;border-color:rgba(255,255,255,.15)!important;background:#151515!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.04)!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-choice>span{display:block!important;min-width:0!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-choice strong{font-size:15px!important;font-weight:900!important;line-height:1.16!important;color:#fff!important;overflow-wrap:normal!important;word-break:normal!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-choice small{margin-top:4px!important;font-size:12px!important;font-weight:650!important;line-height:1.28!important;color:rgba(255,255,255,.64)!important;overflow-wrap:normal!important;word-break:normal!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-choice em{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-width:48px!important;min-height:28px!important;padding:0 10px!important;border-radius:999px!important;background:rgba(197,157,95,.12)!important;color:#d8b36e!important;font-size:12px!important;font-weight:950!important;line-height:1!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-choice.is-active{border-color:rgba(197,157,95,.92)!important;background:linear-gradient(135deg,rgba(197,157,95,.20),rgba(22,18,12,.96))!important;box-shadow:0 0 0 3px rgba(197,157,95,.10),inset 0 1px 0 rgba(255,255,255,.06)!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-choice.is-active em{background:#c59d5f!important;color:#080808!important;}',
      'html body #jsqMobileQuoteApp [data-jsq-mobile-choice="addon"][data-value="none"]{border-color:rgba(130,229,183,.30)!important;background:linear-gradient(135deg,rgba(61,173,120,.14),rgba(15,15,15,.96))!important;}',
      'html body #jsqMobileQuoteApp [data-jsq-mobile-choice="addon"][data-value="none"] em{background:rgba(61,173,120,.16)!important;color:#95efc3!important;}',
      'html body #jsqMobileQuoteApp [data-jsq-mobile-choice="addon"][data-value="none"].is-active{border-color:rgba(130,229,183,.62)!important;box-shadow:0 0 0 3px rgba(61,173,120,.11),inset 0 1px 0 rgba(255,255,255,.06)!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-quote-review-addons{margin-top:10px!important;border-radius:999px!important;box-shadow:0 10px 22px rgba(197,157,95,.20)!important;}',
      'html body #jsqMobileQuoteApp .jsq-mobile-step-nav button,html body #jsqMobileQuoteApp .jsq-mobile-quote-change{border-radius:999px!important;background:rgba(255,255,255,.075)!important;}',
      '}',
      '@media(min-width:701px) and (max-width:1100px){html body #jsqMobileQuoteApp .jsq-mobile-quote-panel,html body #jsqMobileQuoteApp .jsq-mobile-quote-summary{padding:20px!important;border-radius:22px!important;}html body #jsqMobileQuoteApp .jsq-mobile-quote-list{gap:12px!important;}html body #jsqMobileQuoteApp .jsq-mobile-quote-choice{min-height:118px!important;padding:18px!important;border-radius:18px!important;}html body #jsqMobileQuoteApp .jsq-mobile-quote-choice strong{font-size:18px!important;}html body #jsqMobileQuoteApp .jsq-mobile-quote-choice small{font-size:13px!important;line-height:1.34!important;}html body #jsqMobileQuoteApp .jsq-mobile-quote-choice em{min-width:58px!important;min-height:32px!important;font-size:13px!important;}}',
      '@media(max-width:700px){html body #jsqMobileQuoteApp .jsq-mobile-quote-top{padding:14px!important;}html body #jsqMobileQuoteApp .jsq-mobile-quote-panel,html body #jsqMobileQuoteApp .jsq-mobile-quote-summary{padding:13px!important;}html body #jsqMobileQuoteApp .jsq-mobile-quote-choice{min-height:74px!important;padding:13px!important;}html body #jsqMobileQuoteApp[data-step="package"] .jsq-mobile-quote-choice{min-height:82px!important;}html body #jsqMobileQuoteApp .jsq-mobile-quote-choice em{min-width:44px!important;padding:0 9px!important;font-size:12px!important;}html body #jsqMobileQuoteApp .jsq-mobile-quote-step{font-size:9px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function installMobileFormStyle() {
    if (document.getElementById('jsq-mobile-booking-form-polish-v3')) return;
    var style = document.createElement('style');
    style.id = 'jsq-mobile-booking-form-polish-v3';
    style.textContent = [
      '@media(max-width:1100px){',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm{max-width:720px!important;margin:8px auto 0!important;padding:12px!important;border:1px solid rgba(255,255,255,.14)!important;border-radius:18px!important;background:linear-gradient(180deg,rgba(18,18,18,.98),rgba(5,5,5,.98))!important;box-shadow:0 14px 38px rgba(0,0,0,.30)!important;color:#fff!important;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm h3{margin:0 0 4px!important;color:#fff!important;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif!important;font-size:19px!important;font-weight:900!important;line-height:1.1!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-helper{max-width:620px!important;margin:0 0 8px!important;color:rgba(255,255,255,.72)!important;font-size:12px!important;line-height:1.28!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-summary{margin:0 0 8px!important;padding:9px 10px!important;border-radius:13px!important;box-shadow:0 10px 24px rgba(0,0,0,.22)!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-summary h4{display:none!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-total{align-items:center!important;margin:0!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-total strong{font-size:30px!important;line-height:1!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-total span{max-width:112px!important;font-size:10px!important;line-height:1.1!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-line,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-proof,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-fast-actions{display:none!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-lead-grid,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-mini-grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:8px!important;margin:0 0 8px!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field{display:block!important;min-width:0!important;margin:0!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field>span{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:6px!important;margin:0 0 4px!important;color:rgba(255,255,255,.9)!important;font-size:10.5px!important;font-weight:900!important;line-height:1.1!important;letter-spacing:.04em!important;text-transform:uppercase!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field b{display:inline-flex!important;align-items:center!important;min-height:18px!important;padding:0 6px!important;border:1px solid rgba(197,157,95,.4)!important;border-radius:999px!important;background:rgba(197,157,95,.12)!important;color:#d7b674!important;font-size:9.5px!important;font-weight:900!important;line-height:1!important;white-space:nowrap!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field.is-optional b{border-color:rgba(255,255,255,.14)!important;background:rgba(255,255,255,.06)!important;color:rgba(255,255,255,.64)!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field[data-jsq-field="location"],html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field[data-jsq-field="preferred-day"],html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field[data-jsq-field="notes"]{grid-column:1/-1!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field input,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field textarea,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field select{width:100%!important;margin:0!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm input,html body #jsqMobileQuoteFormSlot #quoteRequestForm select,html body #jsqMobileQuoteFormSlot #quoteRequestForm textarea{width:100%!important;max-width:100%!important;min-width:0!important;box-sizing:border-box!important;border:1px solid rgba(255,255,255,.16)!important;border-radius:14px!important;background:#151515!important;color:#fff!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.04)!important;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif!important;font-size:16px!important;font-weight:650!important;line-height:1.2!important;letter-spacing:0!important;outline:none!important;-webkit-appearance:none!important;appearance:none!important;color-scheme:dark!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm input,html body #jsqMobileQuoteFormSlot #quoteRequestForm select{height:48px!important;min-height:48px!important;padding:0 12px!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm select{padding-right:36px!important;background-image:linear-gradient(45deg,transparent 50%,rgba(255,255,255,.84) 50%),linear-gradient(135deg,rgba(255,255,255,.84) 50%,transparent 50%)!important;background-position:calc(100% - 19px) 20px,calc(100% - 13px) 20px!important;background-size:6px 6px,6px 6px!important;background-repeat:no-repeat!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm textarea{display:block!important;min-height:92px!important;padding:12px!important;resize:vertical!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm input::placeholder,html body #jsqMobileQuoteFormSlot #quoteRequestForm textarea::placeholder{color:rgba(255,255,255,.54)!important;font-weight:650!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm input:focus,html body #jsqMobileQuoteFormSlot #quoteRequestForm select:focus,html body #jsqMobileQuoteFormSlot #quoteRequestForm textarea:focus{border-color:rgba(197,157,95,.9)!important;box-shadow:0 0 0 3px rgba(197,157,95,.16),inset 0 1px 0 rgba(255,255,255,.05)!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm option{background:#111!important;color:#fff!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-photo-note{margin:7px 0 8px!important;color:rgba(255,255,255,.7)!important;font-size:12px!important;line-height:1.32!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-final-trust{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:7px!important;margin:8px 0 8px!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-final-trust span{display:flex!important;align-items:center!important;justify-content:center!important;min-height:38px!important;padding:7px 8px!important;border-radius:12px!important;border:1px solid rgba(197,157,95,.30)!important;background:rgba(197,157,95,.08)!important;color:rgba(255,255,255,.84)!important;font-size:11.5px!important;font-weight:850!important;line-height:1.12!important;text-align:center!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-urgency{margin:8px 0 0!important;border-radius:13px!important;background:rgba(197,157,95,.08)!important;color:rgba(255,255,255,.78)!important;font-size:12px!important;line-height:1.32!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm button[type="submit"],html body #jsqMobileQuoteFormSlot #quoteRequestForm input[type="submit"]{width:100%!important;min-height:52px!important;margin-top:8px!important;border:0!important;border-radius:999px!important;background:#c59d5f!important;color:#080808!important;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif!important;font-size:15px!important;font-weight:950!important;line-height:1.1!important;text-align:center!important;white-space:normal!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm button[type="submit"]:not([aria-busy="true"]){font-size:0!important;}',
      'html body #jsqMobileQuoteFormSlot #quoteRequestForm button[type="submit"]:not([aria-busy="true"])::after{content:"Send My Quote Request"!important;font-size:15px!important;font-weight:950!important;line-height:1.1!important;}',
      '}',
      '@media(min-width:701px) and (max-width:1100px){html body #jsqMobileQuoteFormSlot #quoteRequestForm{padding:16px!important;border-radius:20px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm h3{font-size:23px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-helper{font-size:13px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm input,html body #jsqMobileQuoteFormSlot #quoteRequestForm select{height:52px!important;min-height:52px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm textarea{min-height:108px!important;}}',
      '@media(max-width:700px){html body #jsqMobileQuoteFormSlot #quoteRequestForm{width:100%!important;padding:10px!important;border-radius:16px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm h3{font-size:18px!important;margin-bottom:3px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-helper{margin-bottom:7px!important;font-size:12px!important;line-height:1.25!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-summary{margin-bottom:7px!important;padding:8px 9px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-total strong{font-size:27px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-total span{max-width:86px!important;font-size:9px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-lead-grid,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-checkout-mini-grid{grid-template-columns:1fr!important;gap:7px!important;margin-bottom:7px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field>span{margin-bottom:3px!important;font-size:10px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field b{min-height:17px!important;font-size:9px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm input,html body #jsqMobileQuoteFormSlot #quoteRequestForm select,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field input,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field select{height:46px!important;min-height:46px!important;border-radius:12px!important;padding:0 12px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm select{background-position:calc(100% - 19px) 19px,calc(100% - 13px) 19px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm textarea,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-booking-field textarea{min-height:90px!important;border-radius:12px!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-final-trust,html body #jsqMobileQuoteFormSlot #quoteRequestForm .jsq-urgency{display:none!important;}html body #jsqMobileQuoteFormSlot #quoteRequestForm button[type="submit"],html body #jsqMobileQuoteFormSlot #quoteRequestForm input[type="submit"]{min-height:52px!important;margin-top:8px!important;padding:0 14px!important;border-radius:999px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function installOptionalDetailsStyle() {
    if (document.getElementById('jsq-booking-optional-details-style-v2')) return;
    var style = document.createElement('style');
    style.id = 'jsq-booking-optional-details-style-v2';
    style.textContent = [
      '#quoteRequestForm .jsq-booking-optional-details{display:block;margin:8px 0 8px!important;border:1px solid rgba(255,255,255,.14)!important;border-radius:14px!important;background:rgba(255,255,255,.055)!important;color:#fff!important;overflow:hidden!important;}',
      '#quoteRequestForm .jsq-booking-optional-details>summary{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:10px!important;min-height:44px!important;padding:0 12px!important;cursor:pointer!important;color:#f2d08d!important;font-size:12.5px!important;font-weight:950!important;line-height:1.15!important;list-style:none!important;}',
      '#quoteRequestForm .jsq-booking-optional-details>summary::-webkit-details-marker{display:none!important;}',
      '#quoteRequestForm .jsq-booking-optional-details>summary:after{content:"+"!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:22px!important;height:22px!important;border-radius:999px!important;background:rgba(197,157,95,.16)!important;color:#f2d08d!important;font-size:15px!important;line-height:1!important;}',
      '#quoteRequestForm .jsq-booking-optional-details[open]>summary:after{content:"-"!important;}',
      '#quoteRequestForm .jsq-booking-optional-details:not([open]) .jsq-booking-optional-grid{display:none!important;}',
      '#quoteRequestForm .jsq-booking-optional-details[open] .jsq-booking-optional-grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:8px!important;padding:0 12px 12px!important;}',
      '#quoteRequestForm .jsq-checkout-mini-grid:empty{display:none!important;}',
      '#quoteRequestForm .jsq-booking-optional-grid .jsq-booking-field[data-jsq-field="notes"],#quoteRequestForm .jsq-booking-optional-grid .jsq-booking-photo-note{grid-column:1/-1!important;}',
      '@media(max-width:700px){#quoteRequestForm .jsq-booking-optional-details{margin:7px 0 8px!important;border-radius:13px!important;}#quoteRequestForm .jsq-booking-optional-details>summary{min-height:42px!important;padding:0 11px!important;font-size:12.5px!important;}#quoteRequestForm .jsq-booking-optional-details[open] .jsq-booking-optional-grid{grid-template-columns:1fr!important;gap:7px!important;padding:0 10px 10px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function fieldByName(form, name) {
    return form.querySelector('[name="' + name + '"]');
  }

  function setHidden(form, name, value) {
    var input = fieldByName(form, name);
    if (!input || input.tagName === 'SELECT' || input.type !== 'hidden') {
      input = form.querySelector('input[type="hidden"][name="' + name + '"]');
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value || '';
  }

  function leadGrid(form) {
    var grid = form.querySelector('.jsq-checkout-mini-grid');
    if (grid) return grid;
    grid = document.createElement('div');
    grid.className = 'jsq-checkout-mini-grid';
    var anchor = form.querySelector('.jsq-lead-grid');
    if (anchor) anchor.insertAdjacentElement('afterend', grid);
    else form.insertBefore(grid, form.querySelector('textarea') || form.lastElementChild);
    return grid;
  }

  function ensureInput(form, name, placeholder) {
    var input = fieldByName(form, name);
    if (!input || input.tagName !== 'INPUT' || input.type === 'hidden') {
      input = document.createElement('input');
      input.type = 'text';
      input.name = name;
      leadGrid(form).appendChild(input);
    }
    input.placeholder = placeholder;
    input.setAttribute('aria-label', placeholder);
    input.autocomplete = 'off';
    return input;
  }

  function ensureSelect(form, name, label, options) {
    var existing = fieldByName(form, name);
    if (existing && existing.tagName === 'SELECT') return existing;
    var select = document.createElement('select');
    select.name = name;
    select.setAttribute('aria-label', label);
    options.forEach(function (item) {
      var option = document.createElement('option');
      option.value = item[0];
      option.textContent = item[1];
      select.appendChild(option);
    });
    if (existing) {
      if (existing.value) select.value = existing.value;
      existing.replaceWith(select);
    } else {
      leadGrid(form).appendChild(select);
    }
    return select;
  }

  function bindInvalid(field, message) {
    if (!field || field.dataset.jsqBookingInvalidBound === 'true') return;
    field.dataset.jsqBookingInvalidBound = 'true';
    field.addEventListener('invalid', function () {
      if (!clean(field.value)) field.setCustomValidity(message);
    });
    field.addEventListener('input', function () {
      field.setCustomValidity('');
    });
  }

  function wrapBookingField(field, config) {
    if (!field) return;
    field.placeholder = config.placeholder;
    field.setAttribute('aria-label', config.label);
    if (config.autocomplete) field.setAttribute('autocomplete', config.autocomplete);
    if (config.inputmode) field.setAttribute('inputmode', config.inputmode);
    field.required = !!config.required;
    if (config.required) {
      field.setAttribute('aria-required', 'true');
      bindInvalid(field, config.message || (config.label + ' is required.'));
    } else {
      field.removeAttribute('aria-required');
    }

    var wrapper = field.closest('.jsq-booking-field');
    if (!wrapper) {
      wrapper = document.createElement('label');
      wrapper.className = 'jsq-booking-field';
      field.parentNode.insertBefore(wrapper, field);
      wrapper.appendChild(field);
    }

    wrapper.dataset.jsqField = config.key;
    wrapper.classList.toggle('is-optional', !config.required);

    var label = wrapper.querySelector(':scope > span');
    if (!label) {
      label = document.createElement('span');
      wrapper.insertBefore(label, wrapper.firstChild);
    }
    label.innerHTML = '';
    label.appendChild(document.createTextNode(config.label));
    var tag = document.createElement('b');
    tag.textContent = config.required ? 'Required' : 'Optional';
    label.appendChild(tag);
  }

  function ensureOptionalDetails(form) {
    var details = form.querySelector('.jsq-booking-optional-details');
    if (!details) {
      details = document.createElement('details');
      details.className = 'jsq-booking-optional-details';
      var summary = document.createElement('summary');
      summary.textContent = 'Add appointment details';
      var grid = document.createElement('div');
      grid.className = 'jsq-booking-optional-grid';
      details.appendChild(summary);
      details.appendChild(grid);
      var anchor = form.querySelector('.jsq-lead-grid');
      if (anchor) anchor.insertAdjacentElement('afterend', details);
      else form.insertBefore(details, form.querySelector('.jsq-urgency') || form.lastElementChild);
    }
    return details.querySelector('.jsq-booking-optional-grid');
  }

  function arrangeOptionalFields(form) {
    var grid = ensureOptionalDetails(form);
    if (!grid) return;
    ['email', 'preferred-day', 'preferred-timing', 'preferred-contact', 'work-area', 'notes'].forEach(function (key) {
      var wrapper = form.querySelector('.jsq-booking-field[data-jsq-field="' + key + '"]');
      if (wrapper && wrapper.parentNode !== grid) grid.appendChild(wrapper);
    });
    var photoNote = form.querySelector('.jsq-booking-photo-note');
    if (photoNote && photoNote.parentNode !== grid) grid.appendChild(photoNote);
    var miniGrid = form.querySelector('.jsq-checkout-mini-grid');
    if (miniGrid && !miniGrid.children.length) miniGrid.hidden = true;
  }

  function leadSummary(details) {
    return [
      'JS Mobile Detailing Quote Request',
      '',
      'Customer: ' + (details.name || '-'),
      'Phone: ' + (details.customerPhone || '-'),
      'Email: ' + (details.email || '-'),
      'Location: ' + (details.location || '-'),
      '',
      'Quote: ' + details.price,
      'Service: ' + details.service,
      'Vehicle: ' + details.vehicle,
      'Condition: ' + details.condition,
      'Add-ons: ' + details.addons,
      '',
      'Preferred day/date: ' + (details.preferredDay || '-'),
      'Preferred timing: ' + details.preferredTiming,
      'Work area/shade: ' + details.workArea,
      'Contact preference: ' + details.preferredContact,
      '',
      'Photo follow-up: Customer was prompted to text vehicle photos after request if helpful.',
      'Booking stage: Text/call to confirm final price and appointment before booking.',
      '',
      'Customer notes: ' + (details.notes || '-')
    ].join('\n');
  }

  function syncBookingPayload(form) {
    if (!form || form.id !== 'quoteRequestForm') return;
    var details = quoteDetails(form);
    var summary = leadSummary(details);
    setHidden(form, 'contact[Quote Price]', details.price);
    setHidden(form, 'contact[Quote Service]', details.service);
    setHidden(form, 'contact[Vehicle Type]', details.vehicle);
    setHidden(form, 'contact[Vehicle Condition]', details.condition);
    setHidden(form, 'contact[Selected Add-ons]', details.addons);
    setHidden(form, 'contact[Final CTA]', finalCta);
    setHidden(form, 'contact[Photo Follow-up]', 'Customer prompted to text vehicle photos after request if helpful');
    setHidden(form, 'contact[Lead Summary]', summary);
    setHidden(form, 'contact[body]', summary);
    setHidden(form, 'contact[Subject]', 'Quote request - ' + details.service + ' - ' + details.price);
  }

  function polishFinalForm() {
    var form = byId('quoteRequestForm');
    if (!form) return;
    installStyle();
    installMobileFormStyle();
    installOptionalDetailsStyle();
    form.classList.add('jsq-booking-conversion-ready');
    var heading = form.querySelector('h3');
    var helper = form.querySelector('.jsq-helper');
    var notes = fieldByName(form, 'contact[Notes]');
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (heading) heading.textContent = 'Where should we send your quote?';
    if (helper) helper.textContent = 'Name, mobile, and service area are all we need to start.';
    var name = fieldByName(form, 'contact[name]');
    var customerPhone = fieldByName(form, 'contact[phone]');
    var email = fieldByName(form, 'contact[email]');
    var location = fieldByName(form, 'contact[Location]');
    var preferredDay = ensureInput(form, 'contact[Preferred Day]', 'Preferred day or time');
    var preferredTiming = ensureSelect(form, 'contact[Preferred Timing]', 'Best appointment window', [
      ['Next available opening', 'Next available opening'],
      ['Morning preferred', 'Morning preferred'],
      ['Afternoon preferred', 'Afternoon preferred'],
      ['Weekend preferred', 'Weekend preferred'],
      ['Flexible', 'Flexible']
    ]);
    var workArea = ensureSelect(form, 'contact[Work Area]', 'Work area or shade', [
      ['Not sure yet', 'Work area/shade not sure yet'],
      ['Driveway or open parking', 'Driveway or open parking'],
      ['Covered shade or garage', 'Covered shade or garage'],
      ['Street or apartment parking', 'Street or apartment parking']
    ]);
    var preferredContact = ensureSelect(form, 'contact[Preferred Contact]', 'Contact preference', [
      ['Text first', 'Text first'],
      ['Call me', 'Call me'],
      ['Text or call', 'Text or call']
    ]);
    wrapBookingField(name, {
      key: 'name',
      label: 'Name',
      placeholder: 'First name',
      autocomplete: 'name',
      required: true,
      message: 'Please enter your name.'
    });
    wrapBookingField(customerPhone, {
      key: 'phone',
      label: 'Mobile number',
      placeholder: 'Phone for text confirmation',
      autocomplete: 'tel',
      inputmode: 'tel',
      required: true,
      message: 'Please enter a mobile number.'
    });
    wrapBookingField(email, {
      key: 'email',
      label: 'Email',
      placeholder: 'Email address',
      autocomplete: 'email',
      inputmode: 'email',
      required: false
    });
    wrapBookingField(location, {
      key: 'location',
      label: 'Service city or ZIP',
      placeholder: 'Where should we come to?',
      autocomplete: 'postal-code',
      required: true,
      message: 'Please enter the city or ZIP so we can confirm route and availability.'
    });
    wrapBookingField(preferredDay, {
      key: 'preferred-day',
      label: 'Best day or time',
      placeholder: 'Example: Friday morning',
      autocomplete: 'off',
      required: false
    });
    wrapBookingField(preferredTiming, {
      key: 'preferred-timing',
      label: 'Appointment window',
      placeholder: 'Best appointment window',
      required: false
    });
    wrapBookingField(workArea, {
      key: 'work-area',
      label: 'Work area',
      placeholder: 'Work area or shade',
      required: false
    });
    wrapBookingField(preferredContact, {
      key: 'preferred-contact',
      label: 'Contact preference',
      placeholder: 'Contact preference',
      required: false
    });
    if (notes) {
      wrapBookingField(notes, {
        key: 'notes',
        label: 'Vehicle notes',
        placeholder: 'Year, make, model, driveway/shade, pets, odor, stains',
        required: false
      });
      if (!form.querySelector('.jsq-booking-photo-note')) {
        var photoNote = document.createElement('p');
        photoNote.className = 'jsq-booking-photo-note';
        photoNote.textContent = 'Photos help us confirm time and final price. You can text them after sending this.';
        (notes.closest('.jsq-booking-field') || notes).insertAdjacentElement('afterend', photoNote);
      }
    }
	    if (!form.querySelector('.jsq-final-trust')) {
      var trust = document.createElement('p');
      trust.className = 'jsq-final-trust';
      trust.innerHTML = '<span>No payment now</span><span>Final price confirmed by text</span>';
      var urgency = form.querySelector('.jsq-urgency');
      if (urgency) urgency.insertAdjacentElement('beforebegin', trust);
	      else form.appendChild(trust);
	    }
    arrangeOptionalFields(form);
	    if (button && button.dataset.jsqSending !== 'true' && button.getAttribute('aria-busy') !== 'true') {
      if ('value' in button) button.value = finalCta;
      button.textContent = finalCta;
    }
    syncBookingPayload(form);
  }

  var copyGuardInstalled = false;

  function lockFinalCopy() {
    var form = byId('quoteRequestForm');
    if (!form) return;
    var heading = form.querySelector('h3');
    var helper = form.querySelector('.jsq-helper');
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (heading && heading.textContent !== 'Where should we send your quote?') heading.textContent = 'Where should we send your quote?';
    if (helper && helper.textContent !== 'Name, mobile, and service area are all we need to start.') {
      helper.textContent = 'Name, mobile, and service area are all we need to start.';
    }
    if (button && button.dataset.jsqSending !== 'true' && button.getAttribute('aria-busy') !== 'true') {
      if ('value' in button) button.value = finalCta;
      if (button.textContent !== finalCta) button.textContent = finalCta;
      button.dataset.jsqOriginalText = finalCta;
      button.setAttribute('aria-label', finalCta);
      button.setAttribute('title', finalCta);
    }
  }

  function installCopyGuard() {
    if (copyGuardInstalled) return;
    copyGuardInstalled = true;
    var run = function () {
      lockFinalCopy();
      setTimeout(lockFinalCopy, 25);
      setTimeout(lockFinalCopy, 120);
    };
    ['click', 'change', 'input', 'focusin', 'jsq:simple-flow-change', 'jsq:simple-flow-book'].forEach(function (type) {
      document.addEventListener(type, run, true);
    });
    var passes = 0;
    var timer = setInterval(function () {
      lockFinalCopy();
      passes += 1;
      if (passes >= 12) clearInterval(timer);
    }, 180);
    run();
  }

  function patchNativeSubmit() {
    if (!window.HTMLFormElement || window.JSQQuoteNativeSubmitPayloadV1) return;
    var nativeSubmit = HTMLFormElement.prototype.submit;
    if (typeof nativeSubmit !== 'function') return;
    window.JSQQuoteNativeSubmitPayloadV1 = true;
    HTMLFormElement.prototype.submit = function () {
      if (this && this.id === 'quoteRequestForm') syncBookingPayload(this);
      return nativeSubmit.apply(this, arguments);
    };
  }

  function storePending(form, details) {
    try {
      sessionStorage.setItem(key, JSON.stringify(details || quoteDetails(form)));
    } catch (error) {}
  }

  function setSendingState(form) {
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!button || button.dataset.jsqSending === 'true') return;
    button.dataset.jsqSending = 'true';
    button.dataset.jsqOriginalText = button.textContent || button.value || finalCta;

    function apply() {
      if (!document.contains(button) || button.dataset.jsqSending !== 'true') return;
      if ('value' in button) button.value = 'Sending quote...';
      button.textContent = 'Sending quote...';
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }

    apply();
    [80, 220, 480, 900, 1600].forEach(function (delay) {
      setTimeout(apply, delay);
    });
    if (button.__jsqSendingTimer) clearInterval(button.__jsqSendingTimer);
    button.__jsqSendingTimer = setInterval(apply, 75);
    setTimeout(function () {
      if (!document.contains(button)) return;
      if (button.__jsqSendingTimer) clearInterval(button.__jsqSendingTimer);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if ('value' in button) button.value = button.dataset.jsqOriginalText;
      button.textContent = button.dataset.jsqOriginalText;
      button.dataset.jsqSending = 'false';
    }, 9000);
  }

  function contactPosted() {
    var params = new URLSearchParams(window.location.search);
    return params.has('contact_posted') || /contact_posted=true/i.test(window.location.href);
  }

  function pendingQuote() {
    try {
      var data = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!data || !data.at || Date.now() - data.at > 1000 * 60 * 20) return null;
      return data;
    } catch (error) {
      return null;
    }
  }

  function showSuccess() {
    if (!contactPosted() || document.getElementById('jsqQuoteSubmitSuccess')) return;
    var data = pendingQuote();
    if (!data) return;
    installStyle();
    installPostSubmitStyle();
    var card = document.createElement('section');
    var sms = 'sms:' + phone + '?&body=' + encodeURIComponent('Hi JS Mobile, I just sent a quote request for ' + data.service + ' at ' + data.price + '.');
    var summary = '<div class="jsq-submit-success-summary"><p><span>Estimate</span><b>' + html(data.price) + '</b></p><p><span>Service</span><b>' + html(data.service) + '</b></p><p><span>Vehicle</span><b>' + html(data.vehicle) + '</b></p><p><span>Extras</span><b>' + html(data.addons || 'None') + '</b></p></div>';
    var next = '<div class="jsq-submit-next"><span>We review the route</span><span>Final price confirmed first</span><span>Text photos if needed</span></div>';
    card.id = 'jsqQuoteSubmitSuccess';
    card.className = 'jsq-submit-success';
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');
    card.innerHTML = '<p class="jsq-submit-success-kicker">Request sent</p><strong>Your quote is in</strong><p>JS Mobile will text or call to confirm the final price, route, and appointment window before anything is booked.</p>' + summary + next + '<div class="jsq-submit-success-actions"><a href="' + sms + '">Text Photos</a><a href="tel:' + phone + '">Call JS Mobile</a></div>';
    (document.querySelector('main') || document.body).insertBefore(card, (document.querySelector('main') || document.body).firstChild);
    try {
      sessionStorage.removeItem(key);
    } catch (error) {}
    setTimeout(function () {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 120);
  }

  function handleSubmit(event) {
    if (event.__jsqQuoteSubmitHandoffV1) return;
    var form = event.target;
    if (!form || form.id !== 'quoteRequestForm') return;
    event.__jsqQuoteSubmitHandoffV1 = true;
    if (form.reportValidity && !form.reportValidity()) return;
    polishFinalForm();
    syncBookingPayload(form);
    var details = quoteDetails(form);
    if (quoteIncomplete(details)) return;
    storePending(form, details);
    setSendingState(form);
  }

  function bootSuccess() {
    installMobileQuoteStepStyle();
    patchNativeSubmit();
    polishFinalForm();
    installCopyGuard();
    showSuccess();
    [80, 220, 520, 1200].forEach(function (delay) {
      setTimeout(polishFinalForm, delay);
    });
    setTimeout(showSuccess, 120);
    setTimeout(showSuccess, 700);
    setTimeout(showSuccess, 1600);
  }

  document.addEventListener('submit', handleSubmit, true);
  ['click', 'change', 'input', 'jsq:simple-flow-change', 'jsq:simple-flow-book'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (!event.target || !event.target.closest || event.target.closest('#jsqQuoteSection')) {
        setTimeout(polishFinalForm, 0);
        setTimeout(polishFinalForm, 160);
        setTimeout(polishFinalForm, 360);
      }
    }, true);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootSuccess);
  else bootSuccess();
  window.addEventListener('pageshow', bootSuccess);
  var passes = 0;
  var timer = setInterval(function () {
    polishFinalForm();
    passes += 1;
    if (passes >= 12) clearInterval(timer);
  }, 180);
})();

(function () {
  if (window.JSQGlobalSeoContentCleanupV1) return;
  window.JSQGlobalSeoContentCleanupV1 = true;

  var titles = {
    '/pages/contact': 'Request a Mobile Detailing Quote in Spokane',
    '/blogs/news': 'News',
    '/pages/mobile-detailing-spokane': 'Mobile Detailing in Spokane, WA',
    '/pages/mobile-detailing-spokane-valley': 'Mobile Detailing in Spokane Valley, WA',
    '/pages/mobile-detailing-liberty-lake': 'Mobile Detailing in Liberty Lake, WA',
    '/pages/mobile-detailing-airway-heights': 'Mobile Detailing in Airway Heights, WA',
    '/pages/mobile-detailing-cheney': 'Mobile Detailing in Cheney, WA',
    '/pages/mobile-detailing-coeur-dalene': "Mobile Detailing in Coeur d'Alene, ID",
    '/pages/interior-detailing-spokane-js-mobile-detailing': 'Interior Car Detailing in Spokane, WA',
    '/pages/exterior-detailing-spokane': 'Exterior Car Detailing in Spokane, WA',
    '/pages/full-detail-spokane': 'Full Detail Mobile Detailing in Spokane, WA',
    '/pages/ceramic-coating-spokane': 'Ceramic Coating in Spokane, WA',
    '/pages/paint-correction-spokane': 'Paint Correction in Spokane, WA',
    '/pages/boat-detailing-spokane': 'Boat Detailing in Spokane, WA',
    '/pages/rv-detailing-spokane': 'RV Detailing in Spokane, WA',
    '/pages/mobile-detailing-membership-plans-spokane': 'Mobile Detailing Membership Plans in Spokane, WA'
  };

  var quotePages = {
    '/pages/mobile-detailing-spokane': true,
    '/pages/mobile-detailing-spokane-valley': true,
    '/pages/mobile-detailing-liberty-lake': true,
    '/pages/mobile-detailing-airway-heights': true,
    '/pages/mobile-detailing-cheney': true,
    '/pages/mobile-detailing-coeur-dalene': true,
    '/pages/interior-detailing-spokane-js-mobile-detailing': true,
    '/pages/exterior-detailing-spokane': true,
    '/pages/full-detail-spokane': true,
    '/pages/ceramic-coating-spokane': true,
    '/pages/paint-correction-spokane': true,
    '/pages/boat-detailing-spokane': true,
    '/pages/rv-detailing-spokane': true,
    '/pages/mobile-detailing-membership-plans-spokane': true
  };

  function path() {
    return window.location.pathname.replace(/\/$/, '') || '/';
  }

  function removeSection(selector) {
    document.querySelectorAll(selector).forEach(function (node) {
      var section = node.closest('.shopify-section') || node.closest('[id^="shopify-section-"]') || node;
      if (section && section.parentNode) section.parentNode.removeChild(section);
    });
  }

  function demoteExtraH1s(title) {
    var h1s = Array.prototype.filter.call(document.querySelectorAll('h1'), function (node) {
      return !!(node.textContent || '').replace(/\s+/g, ' ').trim();
    });
    if (!h1s.length) return;
    if ((h1s[0].textContent || '').replace(/\s+/g, ' ').trim() !== title) h1s[0].textContent = title;
    h1s.slice(1).forEach(function (heading) {
      var h2 = document.createElement('h2');
      Array.prototype.forEach.call(heading.attributes, function (attribute) {
        if (attribute.name !== 'id') h2.setAttribute(attribute.name, attribute.value);
      });
      while (heading.firstChild) h2.appendChild(heading.firstChild);
      if (heading.parentNode) heading.parentNode.replaceChild(h2, heading);
    });
  }

  function cleanup() {
    var current = path();
    var title = titles[current];
    if (!title || current === '/') return;

    removeSection('.js-home-hero');
    removeSection('.js-seo-home');
    if (!quotePages[current]) removeSection('#jsqQuoteSection');
    if (current !== '/pages/contact') removeSection('.js-contact-section');
    demoteExtraH1s(title);
  }

  function schedule() {
    window.requestAnimationFrame ? window.requestAnimationFrame(cleanup) : setTimeout(cleanup, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('pageshow', schedule);
  setTimeout(cleanup, 400);
  setTimeout(cleanup, 1400);
})();
